export enum BannerType {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
}
